/* eslint-disable */
import {querySelector, querySelectorAll} from "app/lib/helperjs";
import {Overlay} from "./overlay";

const MODAL_CLASS = '._modal';
const MODAL_ATTR = '[data-modal]';
const TARGET_NAME = 'data-target';

/**
 * @deprecated Use Dialog component instead
 */
export class Modal {
    static init() {
        const self = new Modal();

        if (!self.targets.length || !self.modals.length) {
            return;
        }

        self._attachClickEvent();
    }

    get targets() {
        return querySelectorAll(MODAL_CLASS);
    }

    get modals() {
        return querySelectorAll(MODAL_ATTR);
    }

    /** @private */
    _attachClickEvent() {
        this.targets.forEach((target) => {
            const name = target.getAttribute(TARGET_NAME);
            const modal = querySelector(`[data-modal="${name}"]`);

            if (!name || !modal) {
                return;
            }

            target.addEventListener('click', () => {
                window.modal = modal;
                this._toggleModal(modal);
            });
        })
    }

    /** @private */
    _toggleModal(modal) {
        const visibleModal = modal.classList.contains('visible');
        const overlay = Overlay.getDOM;

        if (visibleModal) {
            modal.innerHTML = window.modal.innerHTML;
            modal.classList.remove('visible');
        } else {
            modal.classList.add('visible');
        }

        Overlay.toggle(!visibleModal);

        return overlay.addEventListener('click', () => {
            this._toggleModal(modal);
        });
    }
}
